import { breakpoint, colors, fontSize, fontWeight, mediaQueryHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  profile: css({
    marginBottom: spacing.small,
    display: 'flex',
    flexDirection: 'column',

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
    },
  }),

  avatar: css({
    borderRadius: 50,
    width: 55,

    [mediaQueryHelper(breakpoint.phone)]: {
      width: 65,
      marginRight: spacing.medium,
    },
  }),

  title: css({
    color: colors.oxfordBlue,
    fontSize: fontSize.medium,
    fontWeight: fontWeight.bold,
    lineHeight: '19px',
    marginBottom: 3,
    marginTop: 0,

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.default,
    },
  }),

  desktopTitle: css({
    display: 'none',

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'block',
    },
  }),

  mobileTitle: css({
    display: 'block',
    marginLeft: spacing.default,

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'none',
      marginLeft: 0,
    },
  }),

  status: css({
    gridArea: 'status',
    justifySelf: 'end',
  }),

  text: css({
    color: colors.oxfordBlue,
  }),

  details: css({}),

  subText: css({
    fontSize: fontSize.default,
    color: colors.oxfordBlue,
    lineHeight: 1.2,
    fontWeight: fontWeight.regular,

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
    },
  }),

  boldText: css({
    fontWeight: fontWeight.medium,
  }),

  desktopChip: css({
    marginLeft: 'auto',
    display: 'none',
    paddingTop: 3,
    paddingBottom: 3,

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'flex',
    },
  }),

  roleFlexContainer: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: spacing.small,

    [mediaQueryHelper(breakpoint.phone)]: {
      marginBottom: 0,
    },
  }),

  detailsFlexContainer: css({
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing.small,
    marginLeft: 0,

    [mediaQueryHelper(breakpoint.phone)]: {
      marginLeft: spacing.medium,
    },
  }),
}

export default styles
